export default __webpack_public_path__ + "static/media/search_icon.cc2029c2.svg";